/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Card_Read_MoreInputs */

const en_guide_card_read_more = /** @type {(inputs: Guide_Card_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more →`)
};

const ko_guide_card_read_more = /** @type {(inputs: Guide_Card_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자세히 보기 →`)
};

const ja_guide_card_read_more = /** @type {(inputs: Guide_Card_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続きを読む →`)
};

/**
* | output |
* | --- |
* | "Read more →" |
*
* @param {Guide_Card_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_card_read_more = /** @type {((inputs?: Guide_Card_Read_MoreInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Card_Read_MoreInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_card_read_more(inputs)
	if (locale === "ko") return ko_guide_card_read_more(inputs)
	return ja_guide_card_read_more(inputs)
});